import {businessSvg as Icon__small__businessSvg} from '../Icon__small/Icon__small--business.js'

export var business = {
  name: 'business',
  category: 'icon',
  colorable: true,
  svg: Icon__small__businessSvg,
};
